<template>
  <div class="vip-header" :class="{'is-app': jsBridge.isApp}">
    <div class="vip-header__ctn vip-mobile-header">
      <button v-if="jsBridge.isApp" class="nav" @click="onBack">
        <i class="jin-icon jin-icon_nav-back"></i>
      </button>
      <h3>{{headerTitle}}</h3>
      <button v-if="jsBridge.isApp" class="share" @click="onShare">
        <i class="jin-icon jin-icon_share"></i>
      </button>
    </div>
    <div class="vip-pc-header ">
      <div class="vip-header__ctn">
        <a href="https://www.jin10.com">
        <img
          class="vip-pc-header-logo"
          src="//tv.jin10.com/assets/img/vip/logo.png"
          srcset="//tv.jin10.com/assets/img/vip/logo@2x.png 2x"
        />
        </a>
        <h3>{{headerTitle}}</h3>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  created () {
    if (this.jsBridge.isApp) {
      this.jsBridge.dispatch('hideAppNavbar', {isOnlyGoBackWeb: '0'})
      this.jsBridge.dispatch('setAppStatusBarColor', '0')
    }
  },
  computed: {
    ...mapState(['pageType']),
    headerTitle () {
      return {
        vip: 'VIP会员直播',
        tradingNew: '同声传译'
      }[this.pageType]
    }
  },
  methods: {
    onBack () {
      this.jsBridge.dispatch('goBackApp')
    },
    onShare () {
      this.jsBridge.dispatch('appShare')
    }
  }
}
</script>
<style lang="scss" scoped>
.vip-pc-header-logo {
  width: 120px;
  height: 32px;
  position: absolute;
  left: 0px;
  top:8px;
}
.vip-pc-header {
  position: relative;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 30px;
  padding-right: 30px;
  display: block;
}
.vip-mobile-header {
  display: none;
}
.vip-header {
  margin-bottom: 18px;
  background-color: #21232a;
  &__ctn {
    position: relative;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #c59f6d;
  }
  h3 {
    font-size: 24px;
  }
  button {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background-color: transparent;
    outline: none;
    padding-left: 18px;
    padding-right: 18px;
  }
  .nav {
    left: 0;
  }
  .share {
    right: 0;
  }
}
@media screen and (max-width: 768px) {
  .vip-pc-header {
    display: none;
  }
  .vip-mobile-header {
    display: block;
  }
  .vip-header {
    display: block;
    margin-bottom: 0;
    button {
      display: block;
    }
    &.is-app {
      padding-top: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// VipHeader.vue?96a15b42